import { AdvicePageHeroSectionStyles } from './hero.styles';
import { ChevronRight } from '@exploration/shared-components';
import { HeroSection, HeroSectionProps } from '@exploration/shared-sections';
import { ButtonLinkProps } from '@exploration/shared-types';
import { useRouter } from 'next/router';
import { ReactNode, useEffect, useState } from 'react';

const { ButtonTrigger, Drawer } = AdvicePageHeroSectionStyles;

export interface AdvicePageHeroSectionProps extends HeroSectionProps {
  workingWithUsPageComponent?: ReactNode;
  button: ButtonLinkProps;
}

const AdvicePageHeroSection = ({
  button,
  workingWithUsPageComponent,
  ...heroProps
}: AdvicePageHeroSectionProps) => {
  const [open, setOpen] = useState(false);
  const { asPath, push } = useRouter();

  useEffect(() => {
    if (asPath?.split('#')[1]?.includes('is-working-with-us-drawer-open')) {
      setOpen(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const hash = asPath
      ?.split('#')[1]
      ?.includes('is-working-with-us-drawer-open');

    if (open && !hash) {
      push('#is-working-with-us-drawer-open');
    } else if (!open && hash) {
      push('#');
    }
  }, [open, asPath, push]);

  const buttonComponent =
    button && !!Object.keys(button).length ? (
      <Drawer
        id="working-with-us-drawer"
        open={open}
        setOpen={setOpen}
        trigger={
          <ButtonTrigger {...button}>
            {button.text} <ChevronRight />
          </ButtonTrigger>
        }
        primaryButtonText="Connect with Us"
        onClickPrimary={() =>
          window.location.assign('https://local.thrivent.com/')
        }
        size="xl"
        dataAnalyticsModalName="working-with-us-drawer"
      >
        {workingWithUsPageComponent}
      </Drawer>
    ) : undefined;
  return <HeroSection {...heroProps} actionComponent={buttonComponent} />;
};

export default AdvicePageHeroSection;
